<template>
  <section id="container" class="gnb_pdt">
      <div class="title_wrap">
        <h1> 키오스크 관리 상세</h1>
      </div>
    <!--  기본 정보  -->
    <div class="contents_wrap">
      <ul class="filter_list">
        <li>
          <dd>
            <label>키오스크 ID</label>
            <ul class="w75">
              <li>
                {{ kioskInfo.kioskNo }}
              </li>
            </ul>
          </dd>
          <dd>
            <label>키오스크 용도</label>
            <ul class="w75">
              <template v-for="item in kioskUseScnList ">
              <li v-if="item.cdId == kioskInfo.kioskUseScn">
                {{item.cdNm}}
              </li>
              </template>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>생성 일시</label>
            <ul class="w75">
              <li>
                {{ kioskInfo.frstRgstDt }}
              </li>
            </ul>
          </dd>
          <dd>
            <label>사용 여부</label>
            <ul class="w75">
              <li v-if="kioskInfo.kioskUseYn == 'Y'" >
                {{ '키오스크 사용' }}
              </li>
              <li v-else>
                {{ '미사용' }}
              </li>
            </ul>
          </dd>
        </li>
<!-- <li> -->
<!--          <dd>-->
<!--            <label>사용자 인증</label>-->
<!--            <ul class="w75">-->
<!--              <li v-if="kioskInfo.certyYn == 'Y'" >-->
<!--                {{ '사용' }}-->
<!--              </li>-->
<!--              <li v-else>-->
<!--                {{ '미사용' }}-->
<!--              </li>-->
<!--            </ul>-->
<!--          </dd>-->
      <!-- </li> -->
        <li>
          <dd>
            <li>
              <label>키오스크 명</label>
              <ul class="w75">
                <li>
                  {{ kioskInfo.kioskNm }}
                </li>
              </ul>
            </li>
            <li>
              <label>사업장/거점</label>
              <ul class="w75">
                <li>
                  {{ kioskInfo.facilityNm }} <span class="mgl10">{{ kioskInfo.areaNm }}</span>
                </li>
              </ul>
            </li>
            <li>
              <label>건물/층</label>
              <ul class="w75">
                <li>
                  {{ kioskInfo.buildingNm }}<span class="mgl10">{{ kioskInfo.floorNm}}</span>
                </li>
              </ul>
            </li>
          </dd>
          <dd>
            <label>키오스크 담당자</label>
            <ul >
              <li v-for="item in kioskManagerList"  class="f_l w50 ">
                {{item.userNm + '( ' + telFormat(item.spTelNo) + ' )'}}
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
    <div class="contents_wrap">
      <ul class="filter_list">
        <li>
          <dd>
            <label>현재 버전</label>
            <ul class="w75">
              <li>
                {{ !!kioskInfo.lastVersionNm ? kioskInfo.lastVersionNm : '-' }}
              </li>
            </ul>
          </dd>
          <dd>
            <label>업데이트 버전</label>
            <ul class="w75">
              <li>
                {{ !!kioskInfo.updateVersionNm ? kioskInfo.updateVersionNm : '-' }}
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
    <h2 v-if="lockerList.length !== 0" class="mgt20" >무인보관함 정보</h2>
    <div v-if="lockerList.length !== 0" v-for="(locker, index) in lockerList" :key="index" >
    <div class="contents_wrap mgt10">
      <ul class="filter_list">
        <li>
          <dd>
            <label>무인 보관함 명</label>
            <ul class="w75">
              <li>
              {{locker.lockerNm }}
              </li>
            </ul>
          </dd>
          <dd>
            <label>무인 보관함 위치 설명</label>
            <ul class="w75">
              <li>
                {{ !!locker.lockerDesc ? locker.lockerDesc : '-' }}
              </li>
            </ul>
          </dd>
          <dd>
            <label>사용 여부</label>
            <ul class="w75">
              <li v-if="locker.lockerUseYn == 'Y'" >
                {{ '사용' }}
              </li>
              <li v-else>
                {{ '미사용' }}
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
    </div>
    <!--  버튼 영역  -->
    <div class="button_area w30">
      <ul>
        <li v-if="isSU" class="w25">
          <button type="button" class="large_btn green" @click="redirectToUpdate">수정</button>
        </li>
        <li class="w25">
          <button type="button" class="large_btn" @click="redirectToList">목록</button>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>

import {LogisticsCodeDtlMixin, ZoneMixin} from "@/mixin/Mixin";
import DaumPostcodeWindow from "@/components/DaumPostcodeWindow.vue";
import SearchSendNm from "@/components/send/SearchSendNm.vue";
import ApiUtil from "@/api/api.util";
import Apiconfig from "@/api/api.config"
import {ListBox} from "@progress/kendo-listbox-vue-wrapper";
import ApiConfig from "@/api/api.config";
import EtnersParseUtil from '@/common/etners.parse.util'
import EtnersCommonUtil from '@/common/etners.common.util'

export default {
  name: 'KioskDetail',
  components: {},
  mixins: [LogisticsCodeDtlMixin, ZoneMixin],
  mounted () {
    const vm = this
    vm.getKioskDetail()
  },
  methods: {
    // 키오스크 상세정보 호출 API
    getKioskDetail () {
      const vm = this
      const param = {
        loginUserToken: vm.loginUserToken,
        kioskNo: vm.$route.params.kioskNo,
      }
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/kiosk/kioskDetail.json`
      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          this.$Progress.fail()
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData
        vm.kioskInfo = resultData
        vm.kioskManagerList = resultData.kioskManagerList
        vm.lockerList = resultData.lockerInfoList
      })
    },
    // 전화번호 형식 변경
    telFormat (item) {
      return EtnersParseUtil.convertTelNo(item)
    },
    // 목록으로 이동
    redirectToList () {
      // 데이터 초기화
      // 목록으로 포워딩
      this.$router.push({
        name: 'KioskList'
      })
    },
    // 수정으로 이동
    redirectToUpdate () {
      // lockerId 등록(수정)으로 전달
      const vm = this
      this.$router.push({
        name: 'KioskUpdate',
        params: {
          kioskNo: vm.kioskInfo.kioskNo,
        }
      })
    },
  },

  data () {
    const loginUserData = JSON.parse(sessionStorage.getItem('loginUserData'))
    const isSU = loginUserData.authId === '9999'
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      loginUserData: JSON.parse(sessionStorage.getItem('loginUserData')),
      isSU: isSU,
      //kiosk 기본 정보
      kioskInfo: {},
      kioskManagerList: [],
      lockerList: [],
    }
  }
}
</script>
